// extracted by mini-css-extract-plugin
export var clauseRow = "_c0-6";
export var emptyState = "_c0-b";
export var filterContent = "_c0-a";
export var filterGroup = "_c0-1";
export var filterGroupContainer = "_c0-0";
export var nestedGroup = "_c0-2";
export var nestedGroupDepth1 = "_c0-3";
export var nestedGroupDepth2 = "_c0-4";
export var nestedGroupDepth3 = "_c0-5";
export var operatorAnd = "_c0-8";
export var operatorOr = "_c0-9";
export var operatorToggle = "_c0-7";
export var removeGroupButton = "_c0-c";